import classNames from 'classnames';
import { useField } from 'formik';
import React, { useState } from 'react';
import { useTranslation } from '../../../i18n/use-translation';
import { Icon } from '../../atoms/icon';
import { Size } from '../../enums/size';
import { FieldWrapper } from '../FieldWrapper/FieldWrapper';
import { FileProps } from './props.type';
import * as styles from './styles.module.sass';

export const File = React.memo((props: FileProps) => {
  const { name, inputClassName = '', wrapperClassName, labelClassName, onChange } = props;
  const { t } = useTranslation();
  const [label, setLabel] = useState<string>(t('add_file_text'));
  const [field, meta, helper] = useField(name);

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files?.length) {
      setLabel(
        Array.from(files)
          .map(file => file.name)
          .join(', '),
      );
    }

    helper.setTouched(true, true);
    helper.setValue(props.multiple ? files : files?.[0]);
  };

  return (
    <FieldWrapper
      size={props.size ? props.size : Size.BIG}
      {...props}
      errors={props.errors || meta.error}
      wrapperClassName={classNames(wrapperClassName)}
    >
      <label className={classNames(labelClassName, styles.wrapper)}>
        <Icon className={classNames('icon-icon_plus', styles.outlined)} size={Size.MINIMAL} />
        <span className={styles.label}>{label}</span>
        <input
          name={name}
          type="file"
          onChange={onChangeHandler}
          className={classNames(styles.input)}
        />
        <span className={styles.button}>{t('add_file_btn')}</span>
      </label>
    </FieldWrapper>
  );
});
